/** 格式化工具函数，通过 Date 对象计算偏移量处理时区（统一使用北京时间 UTC+8） */
function getTimeComponents(dateStr) {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return null;

    return {
        year: date.getFullYear(),
        month: String(date.getMonth() + 1).padStart(2, '0'),
        day: String(date.getDate()).padStart(2, '0'),
        hour: String(date.getHours()).padStart(2, '0'),
        minute: String(date.getMinutes()).padStart(2, '0'),
        second: String(date.getSeconds()).padStart(2, '0')
    };
}

/**格式化函数 */
export function formatDateTime(dateStr) {
    const components = getTimeComponents(dateStr);
    if (!components) return dateStr || '';

    return `${components.year}-${components.month}-${components.day} ${components.hour}:${components.minute}:${components.second}`;
}

/** 根据格式字符串格式化日期 */
export function formatDate(dateStr, format = 'YYYY-MM-DD') {
    const components = getTimeComponents(dateStr);
    if (!components) return dateStr || '';

    const map = {
        YYYY: components.year,
        MM: components.month,
        DD: components.day,
    };

    return format.replace(/YYYY|MM|DD/g, match => map[match]);
}

/**格式化函数 */
export function formatTime(dateStr) {
    const components = getTimeComponents(dateStr);
    if (!components) return dateStr || '';

    return `${components.hour}:${components.minute}:${components.second}`;
}
